import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import { Card, CardBody, Button, Spinner } from 'reactstrap';

import Moment from 'react-moment';

import ReactTooltip from 'react-tooltip';

import { Table, Column, HeaderCell, Cell, ColumnGroup } from 'rsuite-table';
import 'rsuite-table/dist/css/rsuite-table.css';

const TableHeight = 500;
const pound = `${'\u00A3'}`;

class PaymentsTable extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    fetchStripeLoginLink: PropTypes.func.isRequired,
    getStripeCompanyStatus: PropTypes.func.isRequired,
    addStripeAccount: PropTypes.func.isRequired,
    getSinglePayment: PropTypes.func.isRequired,
    fetchPaymentTooltips: PropTypes.func.isRequired,
    resendEmail: PropTypes.func.isRequired,
    fetchLinkedAPIs: PropTypes.func.isRequired,
    checkCompStatus: PropTypes.func.isRequired,
    openCodePreview: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  componentDidMount() {

  }

  render() {
    const {
      company,
      companyOwnerData,
      payments,
      paymentTooltips,
      user,
      openCodePreview,
      onScroll,
      sort,
      openResendEmail,
      openConfirmRedeemModal,
      openConfirmModal,

      showNoPermission,
      sortType,
      sortColumn,
      cancelProcessing,
      refundProcessing,
      popupBlocked,
      setupActive,
      stripeStatusFetched,
      resendEmailProcessing,
      redeemProcessing,
      codePreviews,
    } = this.props;

    return (
      <div>
        <Table
          sortType={sortType}
          sortColumn={sortColumn}
          data={payments || []}
          virtualized
          minHeight={TableHeight}
          height={TableHeight}
          headerHeight={64}
          shouldUpdateScroll={false}
          onSortColumn={sort}
          onScroll={onScroll}
          style={{ fontSize: 14, paddingLeft: 17, borderLeft: 0, borderRight: 0, borderBottom: 0 }}
          className="company-dashboard-campaigns-table"
        >
          <Column width={170} sortable resizable fixed>
            <HeaderCell>Order ID</HeaderCell>
            <Cell dataKey="chargeId">
              {(rowData, rowIndex) => {
                return (
                  <div>
                    {rowData.chargeId ? (
                      rowData.chargeId
                    ) : ('-')}
                  </div>
                );
              }}
            </Cell>
          </Column>

          <Column width={170} sortable resizable>
            <HeaderCell>Date</HeaderCell>
            <Cell dataKey="paymentDate">
              {(rowData, rowIndex) => {
                return (
                  <div>
                    {rowData.paymentDate ? (
                      <Moment format="DD-MM-YYYY HH:mm" locale="=uk">
                        {rowData.paymentDate.seconds * 1000}
                      </Moment>
                    ) : (null)}
                  </div>
                );
              }}
            </Cell>
          </Column>

          <Column width={260} sortable resizable>
            <HeaderCell>Status</HeaderCell>
            <Cell dataKey="redeemed">
              {(rowData, rowIndex) => {
                if (rowData.expired) {

                    return (
                      <div>
                        <span>Expired</span>
                        {rowData.expiryDate ? (
                          <span>
                            {` - `}
                            <Moment format="DD/MM/YYYY" locale="=uk">
                              {rowData.expiryDate.seconds ? (rowData.expiryDate.seconds * 1000) : rowData.expiryDate}
                            </Moment>
                          </span>
                        ) : (null)}
                      </div>
                    );
                } else if (rowData.canceled) {
                  if (rowData.refunded) {
                    return (
                      <div>
                        <span>Cancelled (refunded)</span>
                        {rowData.canceledDate ? (
                          <span>
                            {` - `}
                            <Moment format="DD/MM/YYYY" locale="=uk">
                              {rowData.canceledDate.seconds ? (rowData.canceledDate.seconds * 1000) : rowData.canceledDate}
                            </Moment>
                          </span>
                        ) : (null)}
                      </div>
                    );
                  } else {
                    return (
                      <div>
                        <span>Cancelled</span>
                        {rowData.canceledDate ? (
                          <span>
                            {` - `}
                            <Moment format="DD/MM/YYYY" locale="=uk">
                              {rowData.canceledDate.seconds ? (rowData.canceledDate.seconds * 1000) : rowData.canceledDate}
                            </Moment>
                          </span>
                        ) : (null)}
                      </div>
                    );
                  }
                } else if (rowData.used) {
                  if (rowData.refunded) {
                    return (
                      <div>
                        <span>Redeemed (refunded) {`${rowData.redeemedby ? `(${rowData.redeemedby})` : (rowData.redeemedBy ? `(${rowData.redeemedBy})` : '')}`}</span>
                        {rowData.usedDate ? (
                          <span>
                            {` - `}
                            <Moment format="DD/MM/YYYY" locale="=uk">
                              {rowData.usedDate.seconds ? (rowData.usedDate.seconds * 1000) : rowData.usedDate}
                            </Moment>
                          </span>
                        ) : (null)}
                      </div>
                    );
                  } else {
                    return (
                      <div>
                        <span>Redeemed {`${rowData.redeemedby ? `(${rowData.redeemedby})` : (rowData.redeemedBy ? `(${rowData.redeemedBy})` : '')}`}</span>
                        {rowData.usedDate ? (
                          <span>
                            {` - `}
                            <Moment format="DD/MM/YYYY" locale="=uk">
                              {rowData.usedDate.seconds ? (rowData.usedDate.seconds * 1000) : rowData.usedDate}
                            </Moment>
                          </span>
                        ) : (null)}
                      </div>
                    );
                  }
                } else {
                  if (rowData.refunded) {
                    if (rowData.canceled) {
                      return (
                        <div>
                          <span>Cancelled (refunded)</span>
                          {rowData.canceledDate ? (
                            <span>
                              {` - `}
                              <Moment format="DD/MM/YYYY" locale="=uk">
                                {rowData.canceledDate}
                              </Moment>
                            </span>
                          ) : (null)}
                        </div>
                      );
                    } else {
                      return <div> Unused (refunded) </div>;
                    }
                  } else {
                    if (rowData.canceled) {
                      return (
                        <div>
                          <span>Cancelled</span>
                          {rowData.canceledDate ? (
                            <span>
                              {` - `}
                              <Moment format="DD/MM/YYYY" locale="=uk">
                                {rowData.canceledDate}
                              </Moment>
                            </span>
                          ) : (null)}
                        </div>
                      );
                    } else {
                      return <div> Unused </div>;
                    }
                  }
                }
              }}
            </Cell>
          </Column>
          <Column width={200} sortable resizable>
            <HeaderCell>Customer Name</HeaderCell>
            <Cell dataKey="customerName">
              {(rowData, rowIndex) => {
                if (rowData.customerName) {
                  return <div> {rowData.customerName ? rowData.customerName : 'No Account'} </div>;
                } else {
                  return <div> No Account </div>;
                }
              }}
            </Cell>
          </Column>
          <Column width={200} sortable resizable>
            <HeaderCell>Customer Email</HeaderCell>
            <Cell dataKey="customerEmail" />
          </Column>
          <Column width={200} sortable resizable>
            <HeaderCell>Voucher code</HeaderCell>
            <Cell dataKey="voucherCodePreview">
              {(rowData, rowIndex) => {
                return <div onClick={() => { openCodePreview(rowData.dbId); }}> {(codePreviews && codePreviews[rowData.dbId]) ? codePreviews[rowData.dbId] : (rowData.voucherCodePreview ? `${rowData.voucherCodePreview}...` : '-')} </div>;
              }}
            </Cell>
          </Column>
          <Column width={200} sortable resizable>
            <HeaderCell>Campaign/VouchReach</HeaderCell>
            <Cell dataKey="voucherName" />
          </Column>
          <Column width={150} sortable resizable>
            <HeaderCell>{`Face Value (${pound})`}</HeaderCell>
            <Cell dataKey="faceValue">
              {(rowData, rowIndex) => {
                if (rowData.faceValue) {
                  return <div> {rowData.faceValue ? (rowData.faceValue).toFixed(2) : '-'} </div>;
                } else {
                  return <div />;
                }
              }}
            </Cell>
          </Column>
          <Column width={150} sortable resizable>
            <HeaderCell>Discount (%)</HeaderCell>
            <Cell dataKey="discount">
              {(rowData, rowIndex) => {
                return <div> {rowData.discount ? ((rowData.discount === 'Claimed') ? '100%' : `${rowData.discount}%`) : '-'} </div>;
              }}
            </Cell>
          </Column>
          <Column width={150} sortable resizable>
            <HeaderCell>Step</HeaderCell>
            <Cell dataKey="discountStep">
              {(rowData, rowIndex) => {
                if (rowData.discountStep) {
                  if (rowData.discountStep > 3) {
                    return <div> Custom </div>;
                  }
                  return <div> {`${(rowData.discountStep === 'Claimed') ? 'Claimed' : `Step ${rowData.discountStep}`}`} </div>;
                } else {
                  return <div />;
                }
              }}
            </Cell>
          </Column>
          <Column width={170} sortable resizable>
            <HeaderCell>{`Voucher Price (${pound})`}</HeaderCell>
            <Cell dataKey="amount_captured_voucher">
              {(rowData, rowIndex) => (
                <>
                  <div> {rowData.amount_captured_voucher ? (rowData.amount_captured_voucher / 100).toFixed(2) : (rowData.amount_captured ? (rowData.amount_captured / 100).toFixed(2) : '-')} </div>
                </>
              )}
            </Cell>
          </Column>
          <Column width={170} sortable resizable>
            <HeaderCell>{`Custom voucher fee (${pound})`}</HeaderCell>
            <Cell dataKey="customVoucherCommission">
              {(rowData, rowIndex) => (
                <>
                  <div> {rowData.customVoucherCommission ? (rowData.customVoucherCommission / 100).toFixed(2) : '-'} </div>
                </>
              )}
            </Cell>
          </Column>

          {(companyOwnerData && companyOwnerData.showCommission) ? (
            <Column width={150} sortable resizable>
              <HeaderCell>Commission (%)</HeaderCell>
              <Cell dataKey="commission">
                {(rowData, rowIndex) => {
                  return <div> {rowData.commissionPercent ? `${(rowData.commissionPercent * 100)}%` : `-%`} </div>;
                }}
              </Cell>
            </Column>
          ) : (null)}

          <Column width={200} resizable>
            <HeaderCell>Gifting</HeaderCell>
            <Cell>
              {(rowData, rowIndex) => {
                if (rowData.gift) {
                  return <div> Bespoke Email Service </div>;
                } else {
                  return <div> - </div>;
                }
              }}
            </Cell>
          </Column>

          <Column width={160} resizable>
            <HeaderCell>{`Gifting Price (${pound})`}</HeaderCell>
            <Cell>
              {(rowData, rowIndex) => {
                if (rowData.gift && rowData.amount_captured_gift) {
                  return <div> {(rowData.amount_captured_gift / 100).toFixed(2)} </div>;
                } else {
                  return <div> - </div>;
                }
              }}
            </Cell>
          </Column>

          <Column width={210} resizable>
            <HeaderCell>Scheduled</HeaderCell>
            <Cell>
              {(rowData, rowIndex) => {
                if (rowData.giftingData && rowData.giftingData.date) {
                  if (rowData.scheduledEmailSent) {
                    return (
                      <div>
                        <span>{'Sent ('}</span>
                        <Moment format="DD-MM-YYYY HH:mm" locale="=uk">
                          {rowData.giftingData.date.seconds * 1000}
                        </Moment>
                        <span>{')'}</span>
                      </div>
                    );
                  }
                  return (
                    <div>
                      <Moment format="DD-MM-YYYY HH:mm" locale="=uk">
                        {rowData.giftingData.date.seconds * 1000}
                      </Moment>
                    </div>
                  );
                }

                return <div> {'-'} </div>;
              }}
            </Cell>
          </Column>

          <Column width={150} resizable>
            <HeaderCell>Resend email</HeaderCell>
            <Cell dataKey="commission">
              {(rowData, rowIndex) => {
                if (rowData.gift) {
                  return (
                    <div>
                      <Button color="link" disabled={showNoPermission} style={{ paddingTop: 3, paddingBottom: 3 }} onClick={() => openResendEmail(rowData.chargeId, rowData.dbId)}>
                        Enter email
                        {(resendEmailProcessing === rowData.chargeId) ? (
                          <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                        ) : (null)}
                      </Button>
                    </div>
                  );
                } else {
                  return <div> - </div>;
                }
              }}
            </Cell>
          </Column>

          <Column width={150} resizable>
            <HeaderCell>Expiry Date</HeaderCell>
            <Cell dataKey="commission">
              {(rowData, rowIndex) => {
                return (
                  <div>
                    {rowData.expiryDate ? (
                      <span>
                        <Moment format="DD/MM/YYYY" locale="=uk">
                          {rowData.expiryDate.seconds ? (rowData.expiryDate.seconds * 1000) : rowData.expiryDate}
                        </Moment>
                      </span>
                    ) : ('-')}
                  </div>
                );
              }}
            </Cell>
          </Column>

          <Column width={150} resizable>
            <HeaderCell>Manual Redemption</HeaderCell>
            <Cell dataKey="refund button">
              {(rowData, rowIndex) => {
                if (rowData.used || rowData.redeemed) {
                  return <div> - </div>;
                } else {
                  return (
                    <Button
                      color="link"
                      disabled={showNoPermission}
                      style={{ paddingTop: 3, paddingBottom: 3 }}
                      onClick={() => openConfirmRedeemModal(rowData.chargeId, rowData.dbId, (user.role === 'linkedCompanyUser' || company.linkedCompaniesAccount || user.linkedCompaniesAccount))}
                    >
                      <>
                        Redeem
                        {(redeemProcessing === rowData.chargeId) ? (
                          <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                        ) : (null)}
                      </>
                    </Button>
                  );
                }
              }}
            </Cell>
          </Column>

          <ColumnGroup className="text-center" header="Refund">
            <Column width={150} resizable>
              <HeaderCell>Voucher</HeaderCell>
              <Cell dataKey="refund button">
                {(rowData, rowIndex) => {
                  if (rowData.refunded) {
                    return (
                      <div>
                        {rowData.refundDate && rowData.refundDate.seconds ? (
                          <Moment format="DD-MM-YYYY HH:mm" locale="=uk">
                            {rowData.refundDate.seconds ? (rowData.refundDate.seconds * 1000) : rowData.refundDate}
                          </Moment>
                        ) : (null)}
                      </div>
                    );
                  } else if (rowData.voucherRefunded) {
                    return (
                      <div>
                        {rowData.voucherRefundDate && rowData.voucherRefundDate.seconds ? (
                          <Moment format="DD-MM-YYYY HH:mm" locale="=uk">
                            {rowData.voucherRefundDate.seconds ? (rowData.voucherRefundDate.seconds * 1000) : rowData.voucherRefundDate}
                          </Moment>
                        ) : (null)}
                      </div>
                    );
                  } else {
                    return (
                      <div>
                        <Button
                          color="link"
                          disabled={rowData.isClaimedVoucher || rowData.adminRemadeOrder || showNoPermission || (user && user.role === 'linkedCompanyUser')}
                          style={{ paddingTop: 3, paddingBottom: 3 }}
                          onClick={() => openConfirmModal('refundVoucher', rowData.chargeId, rowData.dbId)}
                        >
                          Refund
                          {(refundProcessing === rowData.chargeId) ? (
                            <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                          ) : (null)}
                        </Button>
                      </div>
                    );
                  }
                }}
              </Cell>
            </Column>
            <Column width={150} resizable>
              <HeaderCell>
                Voucher & Gifting
              </HeaderCell>
              <Cell dataKey="refund button">
                {(rowData, rowIndex) => {
                  if (!rowData.gift) {
                    return <div> - </div>;
                  } else if (rowData.giftRefunded) {
                    return <div> - </div>;
                  } else if (rowData.refunded) {
                    return (
                      <div>
                        {rowData.refundDate && rowData.refundDate.seconds ? (
                          <Moment format="DD-MM-YYYY HH:mm" locale="=uk">
                            {rowData.refundDate.seconds ? (rowData.refundDate.seconds * 1000) : rowData.refundDate}
                          </Moment>
                        ) : (null)}
                      </div>
                    );
                  } else {
                    return (
                      <div>
                        <Button
                          color="link"
                          disabled={rowData.isClaimedVoucher || rowData.adminRemadeOrder || showNoPermission || (user && user.role === 'linkedCompanyUser')}
                          className={(((rowData.paymentDate.seconds * 1000) + (1000 * 60 * 60 * 24 * 14)) <= Date.now()) ? 'company-payments-disabled-button' : ''}
                          style={{ paddingTop: 3, paddingBottom: 3 }}
                          onClick={() => openConfirmModal((((rowData.paymentDate.seconds * 1000) + (1000 * 60 * 60 * 24 * 14)) <= Date.now()) ? null : rowData.voucherRefunded ? 'refundGifting' : 'refundAll', rowData.chargeId, rowData.dbId)}
                          data-tip
                          data-for='refund-tooltip'
                          for="refund-tooltip"
                        >
                          Refund
                          {(refundProcessing === rowData.chargeId) ? (
                            <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                          ) : (null)}
                        </Button>
                        {paymentTooltips && paymentTooltips.companyPAymentRefund14days && (((rowData.paymentDate.seconds * 1000) + (1000 * 60 * 60 * 24 * 14)) <= Date.now()) ? (
                          <ReactTooltip place="left" className='react-tooltip-custom-class react-tooltip-custom-class-company-payment' effect="solid" id='refund-tooltip'>
                            <span>{paymentTooltips.companyPAymentRefund14days ? paymentTooltips.companyPAymentRefund14days.value : ''}</span>
                          </ReactTooltip>
                        ) : (null)}
                      </div>
                    );
                  }
                }}
              </Cell>
            </Column>
          </ColumnGroup>
          <Column width={150} resizable>
            <HeaderCell>Cancel</HeaderCell>
            <Cell dataKey="refund button">
              {(rowData, rowIndex) => {
                if (rowData.canceled) {
                  return (
                    <div>
                      {rowData.canceledDate ? (
                        <Moment format="DD/MM/YYYY" locale="=uk">
                          {rowData.canceledDate}
                        </Moment>
                      ) : (null)}
                    </div>
                  );
                } else if (rowData.used) {
                  return <div> Used </div>;
                } else {
                  return (
                    <Button
                      color="link"
                      disabled={showNoPermission || (user && user.role === 'linkedCompanyUser')}
                      style={{ paddingTop: 3, paddingBottom: 3 }}
                      onClick={() => openConfirmModal('cancel', rowData.chargeId, rowData.dbId)}
                    >
                      Cancel
                      {(cancelProcessing === rowData.chargeId) ? (
                        <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                      ) : (null)}
                    </Button>
                  );
                }
              }}
            </Cell>
          </Column>
        </Table>
      </div >
    );
  }
}

export default withRouter(PaymentsTable);
